import { render, staticRenderFns } from "./RestaurantsView.vue?vue&type=template&id=c96e41d2&"
import script from "./RestaurantsView.vue?vue&type=script&lang=ts&"
export * from "./RestaurantsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports